import React, { useState, useContext, createContext } from "react";
import axios from "axios";
import authHeader from "./auth-header";
import getmainurl from "./tools.service";

const authContext = createContext();

/* -------------------------------------------------------------------------------- *\
|                               ProvideAuth
\* -------------------------------------------------------------------------------- */
export const ProvideAuth = ({ children }) =>
{
    const auth = useProvideAuth();
    return (
        <authContext.Provider value={auth}>
            {children}
        </authContext.Provider>
    )
}
/* -------------------------------------------------------------------------------- *\
|                               useAuth
\* -------------------------------------------------------------------------------- */
export const useAuth = () =>
{
    return useContext(authContext);
};

/* -------------------------------------------------------------------------------- *\
|                               useProvideAuth
\* -------------------------------------------------------------------------------- */
function useProvideAuth()
{
    const [user, set_user] = useState(false);

    const login = (login, password) =>
    {
        return axios
            .post(getmainurl() + "/api/v1/auth/signin", {
                login,
                password,
            })
            .then((response) =>
            {
                if (response.data.accessToken)
                {
                    localStorage.setItem("user", JSON.stringify(response.data));
                }
                set_user(response.data);
                return response.data;
            });
    };

    const logout = async () =>
    {
        return await axios({
            url: getmainurl() + "/api/v1/auth/signout",
            method: 'post',
            headers: authHeader(),
        })
            .then((response) =>
            {
                localStorage.removeItem("user");
                set_user(false);
                return true;
            }).catch(err =>
            {
                return false;
            });
    };

    const auth_from_storage = async () =>
    {
        let u = localStorage.getItem("user");
        if (u)
        {
            return await axios({
                url: getmainurl() + "/api/v1/auth/checklogged",
                method: 'post',
                headers: authHeader(),
            })
                .then((response) =>
                {
                    set_user(u);
                    return true;
                })
                .catch(err =>
                {
                    set_user(false);
                    localStorage.removeItem('user');
                    return false;
                });
        }
        return false;
    }

    return {
        user,
        login,
        logout,
        auth_from_storage
    }
}
